import { render, staticRenderFns } from "./FileViewerModal.vue?vue&type=template&id=e180e846&scoped=true&"
import script from "./FileViewerModal.vue?vue&type=script&lang=js&"
export * from "./FileViewerModal.vue?vue&type=script&lang=js&"
import style0 from "./FileViewerModal.vue?vue&type=style&index=0&id=e180e846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e180e846",
  null
  
)

export default component.exports